import { MonetizationIcon, Tag } from '@mercai/clever'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { CardInfo } from '@/components'

import styles from './card-order-shipment-invoices.module.css'

import { formatCurrency } from '@/helpers'
import type { CardOrderShipmentInvoiceProps } from './card-order-shipment-invoices.type'

export const CardOrderShipmentInvoice = ({
  isLoading,
  shipmentInvoices = [],
}: CardOrderShipmentInvoiceProps) => {
  const { t: tEnums } = useTranslation('enums')
  const { t } = useTranslation('componentCardsOrderCenterShow')

  const statuses: Record<string, ReactNode> = {
    created: (
      <Tag variant="basic" model="light">
        {tEnums('shipment_invoice_status_created')}
      </Tag>
    ),
    pending: (
      <Tag variant="warning" model="light">
        {tEnums('shipment_invoice_status_pending')}
      </Tag>
    ),
    request_review: (
      <Tag variant="info" model="light">
        {tEnums('shipment_invoice_status_request_review')}
      </Tag>
    ),
    paid: (
      <Tag variant="success" model="light">
        {tEnums('shipment_invoice_status_paid')}
      </Tag>
    ),
    cancelled: (
      <Tag variant="danger" model="light">
        {tEnums('shipment_invoice_status_cancelled')}
      </Tag>
    ),
  }

  return (
    <div className={styles.core}>
      <CardInfo
        isLoading={isLoading}
        icon={<MonetizationIcon />}
        title={t('orderShipmentInvoiceTitle')}
      >
        <div className={styles.shipments}></div>
        {shipmentInvoices?.map((shipmentInvoice) => (
          <div className={styles.shipment} key={shipmentInvoice.uuid}>
            <div>{shipmentInvoice?.transportCompany?.name}</div>
            <div>
              {shipmentInvoice?.status
                ? statuses[shipmentInvoice?.status]
                : '-'}
            </div>
            <div className={styles['shipment-value']}>
              {shipmentInvoice?.value
                ? formatCurrency(
                    shipmentInvoice?.value,
                    'es-MX',
                    shipmentInvoice?.currency || 'MXN',
                  )
                : '-'}
            </div>
          </div>
        ))}
      </CardInfo>
    </div>
  )
}
